import JSEncrypt from 'jsencrypt';

interface KeyPair {
  publicKey: string;
  privateKey: string;
}

export const generateKeyPair = (): KeyPair => {
  const encrypt = new JSEncrypt({ default_key_size: '2048' });
  const publicKey = encrypt.getPublicKey();
  const privateKey = encrypt.getPrivateKey();
  
  if (!publicKey || !privateKey) {
    throw new Error('Failed to generate RSA key pair');
  }

  return {
    publicKey,
    privateKey
  };
};

export const decryptData = (encryptedData: string, privateKey: string): string => {
  const decrypt = new JSEncrypt();
  decrypt.setPrivateKey(privateKey);
  
  const decrypted = decrypt.decrypt(encryptedData);
  if (!decrypted) {
    throw new Error('Failed to decrypt data');
  }
  
  return decrypted;
}; 